'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'lamp-desk';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e014';
var svgPathData = 'M381.3 96L480 96 288 288V189.3c0-8.5-3.4-16.6-9.4-22.6l-38.1-38.1C230 118 224 103.6 224 88.6C224 57.3 249.3 32 280.6 32c15 0 29.4 6 40 16.6l38.1 38.1c6 6 14.1 9.4 22.6 9.4zm0-32L343.2 25.9C326.6 9.3 304.1 0 280.6 0C231.7 0 192 39.7 192 88.6c0 21.7 7.9 42.5 22.2 58.6l-97.5 97.5c-4 4-5.6 9.9-4.1 15.4L171.2 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H192 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H204.3L145.8 260.8l90.8-90.8L256 189.3V288c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l192-192c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H381.3zm-2.6 223.9C391 298 406.8 304 424 304c39.8 0 72-32.2 72-72c0-17.2-6-33-16.1-45.4L457 209.5c4.4 6.4 7 14.2 7 22.5c0 22.1-17.9 40-40 40c-8.4 0-16.1-2.6-22.5-7l-22.8 22.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLampDesk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;